import React, { Fragment } from 'react';
import validator from 'validator';
import { Link } from 'react-router-dom';
import { Popup, EditableComponent, InputField } from 'arteia-js/components';
import { API } from 'arteia-js/services';

class ForgotPassword extends EditableComponent {
    state = {
        passwordFocused: false,
        email: '',
        loading: false,
        sent: false,
    };

    isDataCorrect = () => {
        const { email } = this.state;
        return validator.isEmail(email);
    };


    submit = () => {
        const { email } = this.state;
        this.setState({ loading: true });

        API.post('/forgot-password', {
            email,
        }).then(() => {
            this.setState({
                loading: false,
                sent: true,
            });
        }).catch((e) => {
            this.setState({
                loading: false,
                error: true,
                errorCode: e.status,
                errorMessage: this.ERROR_MESSAGES[e.status],
            });
        });
    };

    handleKeyPress = (e) => {
        if (e.key === 'Enter' && this.isDataCorrect()) {
            this.submit();
        }
    };

    goToLoginPage = () => {
        const { history } = this.props;
        return history.push('/login');
    };

    ERROR_MESSAGES = {
        404: 'Ooops',
        500: 'Something went wrong',
    };


    render() {
        const {
            email,
            sent,
        } = this.state;
        return (
            <Popup size='form' className="forgot-password">
                <div className="popup-content">

                    {sent
                    && <Fragment>
                        <div className="email-sent">
                            <i className="icon-icon_ok"/>
                            <h1>Success</h1>
                            <p>We've sent an email with password reset instructions.</p><br/>
                            <p className="muted">If the email doesn't show up soon, check your spam folder. We sent it
                                from service@arteia.co.</p><br/>
                        </div>

                        <button className="art-btn" onClick={this.goToLoginPage}>
                            Return to Login
                        </button>
                    </Fragment>
                    }
                    {!sent
                    && <Fragment>
                        <h1>Reset your password</h1>
                        <p>Please provide your email so we can send you instructions on how to reset
                            your password</p>
                        <InputField
                            type={'email'}
                            label={'Email'}
                            value={email}
                            onChange={this.onFieldChange('email')}
                            handleKeyPress={this.handleKeyPress}
                        />
                        <button className="art-btn" disabled={!this.isDataCorrect()} onClick={this.submit}>
                            Reset password
                        </button>

                        <Link className="secondary-link" to="/login">Back to login</Link>
                    </Fragment>
                    }

                </div>

            </Popup>
        );
    }
}

ForgotPassword.propTypes = {};
ForgotPassword.defaultProps = {};

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/scenes/ForgotPassword/index.js